import { getYoutubeCode } from "./getYoutubeCode";

export function getYoutubeThumbnail(url) {
  const youtubeCode = getYoutubeCode(url);

  return `https://i3.ytimg.com/vi/${youtubeCode}/hqdefault.jpg`;
}
